export default __webpack_public_path__ + "static/media/student4.85d40009.jpg";